import { render, staticRenderFns } from "./OceanDataMap.vue?vue&type=template&id=16b66564&scoped=true"
import script from "./OceanDataMap.vue?vue&type=script&lang=js"
export * from "./OceanDataMap.vue?vue&type=script&lang=js"
import style0 from "./OceanDataMap.vue?vue&type=style&index=0&id=16b66564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b66564",
  null
  
)

export default component.exports